import React from 'react'

export default function LegalCompliance() {
  return (
    <div>LegalCompliance</div>
  )
}
